import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

export default function BottomNav({ unreadCount = 0 }) {
  const location = useLocation();
  const { t } = useTranslation();
  
  const navItems = [
    { path: "/browse", label: t('nav.shop'), icon: "🛍️" },
    { path: "/create", label: t('nav.sell'), icon: "➕" },
    { path: "/my-listings", label: t('nav.myItems'), icon: "📦" },
    { path: "/favorites", label: t('nav.favorites'), icon: "❤️" },
    { path: "/messages", label: t('nav.messages'), icon: "💬" }
  ];

  return (
    <nav className="modern-bottom-nav">
      <div className="container-center mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-button ${isActive ? 'active' : ''}`}
              >
                <span className="relative text-lg">
                  {item.icon}
                  {item.path === "/messages" && unreadCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5 min-w-[20px] text-center font-bold shadow">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </span>
                <span className="text-xs font-medium leading-tight">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}